<template>
    <div class="work">
        <div class="heading4">Work & Education</div>
        <div class="content">
           <WorkEducation
                            class="zero"
                            :isWork="work_education[0].icon"
                            :ins="work_education[0].ins"
                            :title="work_education[0].title"
                            :location="work_education[0].location"
                            :years="work_education[0].years"
                            :details="work_education[0].details"
                            /> 
            <WorkEducation 
                            class="one"
                            :isWork="work_education[1].icon"
                            :ins="work_education[1].ins"
                            :title="work_education[1].title"
                            :location="work_education[1].location"
                            :years="work_education[1].years"
                            :details="work_education[1].details"
                            /> 
            <WorkEducation 
                            class="two"
                            :isWork="work_education[2].icon"
                            :ins="work_education[2].ins"
                            :title="work_education[2].title"
                            :location="work_education[2].location"
                            :years="work_education[2].years"
                            :details="work_education[2].details"
                            />
            <WorkEducation 
                            class="three"
                            :isWork="work_education[3].icon"
                            :ins="work_education[3].ins"
                            :title="work_education[3].title"
                            :location="work_education[3].location"
                            :years="work_education[3].years"
                            :details="work_education[3].details"
                            />
        </div>
    </div>
</template>
<script>
import WorkEducation from './WorkEducation.vue';
export default{
    components:{
        WorkEducation
    },
    data(){
        return{
           work_education:[
            {
                icon:true,
                ins:"Software Engineer Intern",
                title:"Sparc Systems Limited",
                location:"Blantyre, Malawi",
                years:"Jan 2023 - Feb 2024",
                
            },
            {
                icon:true,
                ins:"Freelance Developer",
                title:"Freelance/Contractor",
                location:"Blantyre, Malawi",
                years:"Feb 2024 - Present",
               
            },
            {
                icon:false,
                ins:"Bachelor's Degree in Information Technology",
                title:"Blantyre International University",
                location:"Blantyre, Malawi",
                years:"Jan 2015 - Sept 2021",
               
            },
            {
                icon:false,
                ins:"Malawi School Certificate of Education",
                title:"Chichiri Secondary School",
                location:"Blantyre, Malawi",
                years:"2010 - 2014",
            },

           ] 
        }
    }
}
</script>
<style scoped>



.box{
    margin-right:2rem;
}



.years{
    color:var(--grey);
}




.work{
    padding:2rem;
}

.content{
    display:grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap:1.5rem;
    margin-top:1.6rem;
}
.box{
    flex:1;
}

.zero{
    grid-column:1/2;
}

.one{
    grid-row:2/3;
}

.two{
    grid-column:2/3;
}

.three{
    grid-column:2/3;
    grid-row:2/3;
}

@media(max-width: 768px){
    .content{
        display:flex;
        flex-direction: column;
    }

    .work{
    padding:1rem;
}

    .zero, .one, .two, .three{
        grid-column:auto
    }


.box{
    margin-right:0rem;
}


}
</style>